import { combineLatestHandler } from './combine-latest';
import { filterHandler } from './filter';
import { mapHandler } from './map';
import { registerHandlers } from './registry';
import { takeHandler } from './take';
import { switchMapHandler } from './switch-map';
import { takeUntilHandler } from './take-until';
import { zipHandler } from './zip';

registerHandlers({
  map: mapHandler,
  filter: filterHandler,
  take: takeHandler,
  takeUntil: takeUntilHandler,
  switchMap: switchMapHandler,
  zip: zipHandler,
  combineLatest: combineLatestHandler,
});

export { getHandler } from './registry';
